import { useAdiaStore } from '@/lib/store';

/**
 * A share step may continue only while its prayer still exists in the live
 * store. PrayPage and PrayerDetail call this before Choice routing, and
 * LetThemKnowSheet / MailCardSheet call it again (through their
 * `authorizeOutbound` prop) before the final render, copy, download or send.
 * A prayer deleted mid-flow therefore closes the flow instead of sending a
 * stale card. Every share still begins with the user's own tap.
 */
export function isLiveSharePrayer(prayerId: string): boolean {
  return useAdiaStore.getState().prayers.some((prayer) => prayer.id === prayerId);
}
